// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__157lk","icon":"SortAdornment_icon__4KN5p","up":"SortAdornment_up__3WN6U","down":"SortAdornment_down__AfKZV","active":"SortAdornment_active__xSvJJ"};